@if (isEsko) {
  <mat-icon fontSet="zefplayer" [ngClass]="class">esko_menu</mat-icon>
} @else {
  <mat-icon fontSet="zefplayer" [ngClass]="class">zef_menu</mat-icon>
}
